import { createSelector } from '@ngrx/store';

import { productImagesState } from '../root';

export const getImageForProduct = (productId: number) =>
    createSelector(productImagesState, (productImages) => productImages.find((productImage) => productImage.ProductId === productId) || null);
